import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationHobbiesAndInterests: React.FC<
  React.PropsWithChildren<Props>
> = ({ theme, ...otherProps }) => {
  return (
    <svg
      width={304}
      height={304}
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clipPath="url(#clip0_1627_10641)">
        <path stroke="#C0C2C9" d="M0 304.03L304 304.03"></path>
        <path
          fill="#F0F1F3"
          d="M280.092 64.714l-1.684-2.77c-14.173-23.332-39.798-37.398-66.823-35.69a71.66 71.66 0 00-10.364 1.417c-24.563 5.254-45.938 23.811-54.8 47.577-5.182 13.976-6.665 30.074-16.556 41.165-12.871 14.442-34.72 14.882-53.926 14.293-19.205-.589-41.074-.084-53.88 14.409-8.019 9.059-10.571 22-9.923 34.145 1.73 32.203 24.16 60.983 52.74 75.289 28.579 14.306 62.184 15.588 93.432 9.298 43.814-8.819 85.419-33.031 110.448-70.424 25.029-37.392 31.358-88.34 11.336-128.709z"
        ></path>
        <ellipse
          cx="66.777"
          cy="89.166"
          fill="#F0F1F3"
          rx="25.636"
          ry="25.636"
        ></ellipse>
        <circle cx="266.704" cy="248.504" r="20.786" fill="#F0F1F3"></circle>
        <path
          fill="#222"
          d="M159.829 87.64a2 2 0 012.345-1.582l104.828 20.371 12.968 2.521a1.998 1.998 0 011.582 2.344l-33.668 173.248a2 2 0 01-2.345 1.582l-117.796-22.892a2 2 0 01-1.581-2.345l33.667-173.248z"
          opacity="0.15"
        ></path>
        <rect
          width="124"
          height="180.489"
          x="153.322"
          y="78.788"
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          rx="2"
          transform="rotate(10.997 153.322 78.788)"
        ></rect>
        <path
          fill="#575B66"
          d="M212.22 259.358c-.034.174-13.532-2.295-30.138-5.523-16.606-3.228-30.054-5.996-30.02-6.17.034-.174 13.532 2.295 30.146 5.524 16.613 3.23 30.048 5.983 30.012 6.169z"
        ></path>
        <rect
          width="92.37"
          height="48.023"
          x="166.568"
          y="103.396"
          fill="#fff"
          rx="2"
          transform="rotate(10.997 166.568 103.396)"
        ></rect>
        <path
          fill="#575B66"
          d="M223.352 127.804c-.034.174-11.715-1.942-26.081-4.734-14.366-2.793-25.996-5.208-25.962-5.382.034-.174 11.715 1.942 26.087 4.736 14.373 2.794 25.992 5.194 25.956 5.38zM243.202 142.175c-.034.174-16.56-2.884-36.9-6.838-20.339-3.953-36.816-7.311-36.783-7.485.034-.174 16.561 2.884 36.909 6.839 20.348 3.956 36.81 7.297 36.774 7.484zM227.333 148.671c-.034.174-13.532-2.295-30.138-5.523-16.605-3.228-30.053-5.997-30.019-6.171.033-.174 13.532 2.295 30.145 5.525 16.613 3.229 30.048 5.982 30.012 6.169z"
        ></path>
        <path
          stroke="#222"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M156.091 84.299l-32.378 168.089"
          opacity="0.3"
        ></path>
        <path
          fill="#DBDDE1"
          d="M26.837 59.245a2 2 0 01.673-2.747l8.193-4.969a2 2 0 012.747.673l1.31 2.161-11.612 7.043-1.31-2.16z"
        ></path>
        <path
          fill="#222"
          d="M26.837 59.245a2 2 0 01.673-2.747l8.193-4.969a2 2 0 012.747.673l1.31 2.161-11.612 7.043-1.31-2.16z"
          opacity="0.3"
        ></path>
        <path
          fill="#DBDDE1"
          d="M28.342 59.245a2 2 0 01.673-2.747l8.193-4.969a2 2 0 012.747.673l1.31 2.161-11.612 7.043-1.31-2.16z"
        ></path>
        <rect
          width="113.178"
          height="67.907"
          x="27.54"
          y="66.961"
          fill="#222"
          opacity="0.15"
          rx="6"
          transform="rotate(-31.236 27.54 66.96)"
        ></rect>
        <rect
          width="113.178"
          height="67.907"
          x="20.016"
          y="65.456"
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          rx="6"
          transform="rotate(-31.236 20.016 65.456)"
        ></rect>
        <mask
          id="mask0_1627_10641"
          style={{ maskType: 'alpha' }}
          width="128"
          height="113"
          x="22"
          y="9"
          maskUnits="userSpaceOnUse"
        >
          <rect
            width="113.178"
            height="67.907"
            x="20.016"
            y="65.456"
            fill={theme ? theme.primary[500] : '#C0C2C9'}
            rx="6"
            transform="rotate(-31.236 20.016 65.456)"
          ></rect>
        </mask>
        <g mask="url(#mask0_1627_10641)">
          <path
            fill="#575B66"
            d="M29.015 80.294H142.19299999999998V126.32H29.015z"
            transform="rotate(-31.236 29.015 80.294)"
          ></path>
          <ellipse
            cx="108.079"
            cy="60.504"
            fill="#222"
            opacity="0.3"
            rx="27.917"
            ry="27.917"
            transform="rotate(-31.236 108.079 60.504)"
          ></ellipse>
          <path
            fill="#222"
            stroke="#3F424B"
            d="M122.492 44.781c7.852 12.947 3.722 29.808-9.225 37.66-12.947 7.853-29.808 3.723-37.66-9.225-7.853-12.947-3.722-29.808 9.225-37.66 12.947-7.852 29.808-3.722 37.66 9.225z"
          ></path>
          <path
            stroke="#3F424B"
            d="M119.912 46.346c6.988 11.522 3.312 26.527-8.21 33.515-11.521 6.988-26.527 3.312-33.514-8.21-6.988-11.521-3.313-26.526 8.21-33.514 11.521-6.988 26.526-3.313 33.514 8.21z"
          ></path>
          <path
            fill="#3F424B"
            stroke="#3F424B"
            d="M116.685 48.302c5.907 9.74 2.8 22.426-6.94 28.333-9.741 5.907-22.426 2.8-28.333-6.94-5.908-9.74-2.8-22.425 6.94-28.333 9.74-5.907 22.425-2.8 28.333 6.94z"
          ></path>
          <path
            fill="#575B66"
            d="M115.029 61.037c-1.532-2.049-3.915-1.68-5.846-.823-4.094 1.76-7.713 5.431-12.148 5.11a7.394 7.394 0 01-6.35-5.007c-.679-2.074-.618-4.84-2.78-5.625a3.09 3.09 0 00-2.514.239c-.719.41-1.332.98-1.793 1.666a7.56 7.56 0 00-1.336 4.981 16.534 16.534 0 005.46 10.807 17.363 17.363 0 0014.419 4.242 17.915 17.915 0 0012.34-8.642c.979-1.7 1.696-3.641 1.17-5.628a3.926 3.926 0 00-.622-1.32z"
          ></path>
          <ellipse
            cx="92.524"
            cy="47.513"
            fill="#575B66"
            rx="2.641"
            ry="2.641"
            transform="rotate(-31.236 92.524 47.513)"
          ></ellipse>
          <rect
            width="18.059"
            height="7.525"
            x="30.105"
            y="65.555"
            fill="#fff"
            rx="1"
            transform="rotate(-31.24 30.105 65.555)"
          ></rect>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1627_10641">
          <path
            fill="#fff"
            d="M0 0H304V304H0z"
            transform="translate(0 .53)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationHobbiesAndInterests;
